import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(enLocale);

function countryCodeToFlag(code: string): string {
  return code
    .toUpperCase()
    .split('')
    .map((char) => String.fromCodePoint(0x1f1e6 + char.charCodeAt(0) - 65))
    .join('');
}

export interface CountryOption {
  value: string;
  label: string;
  flag: string;
}

const allCountries = countries.getNames('en', { select: 'official' });

export const COUNTRY_OPTIONS: CountryOption[] = Object.entries(allCountries)
  .map(([code, name]) => ({
    value: name,
    label: name,
    flag: countryCodeToFlag(code),
  }))
  .sort((a, b) => a.label.localeCompare(b.label));
